import Widget from '@/plugins/dashboard/widgets/Comparison/Widget'
import Configure from '@/plugins/dashboard/widgets/Comparison/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Comparison'
  static widget = Widget
  static configure = Configure
}
